import { createContext, type PropsWithChildren, useContext, useMemo } from 'react'

export type TabColor = 'primary' | 'grey' | 'blue' | 'red'
export type TabValue = string | number
export interface TabContextProps {
  /** 目前選取的標籤值 */
  value?: TabValue
}
const Context = createContext<TabContextProps>({})

/**
 * TabContext 提供標籤頁的共享狀態（目前選取值），
 * 讓 TabList 與 TabPanel 能自動同步。
 */
export const TabContext = (props: PropsWithChildren<TabContextProps>) => {
  const { value, children } = props

  const context = useMemo(() => ({ value }), [value])

  return <Context.Provider value={context}>{children}</Context.Provider>
}

export const useTabContext = () => {
  const context = useContext(Context)

  return context
}
